// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__NgWUM","overflowing":"ReadFullNote_overflowing__2kH3T"};